import { routeOrgScoped } from './catalog'

const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

// Operators in words, for the filter dropdown and the summaries.
export const OP_WORDS = { equals: 'is', not_equals: 'is not', contains: 'contains', not_contains: "doesn't contain", in: 'is one of', not_in: 'is not one of', gte: 'at least', lte: 'at most', exists: 'is set' }

// The word for one alert of a category: "Every error alert", "All SSO
// alerts". The catalog's alertNoun wins when the server sends one; the four
// seeded categories (spec §13.1) have their word here until it does.
const NOUNS = { errors: 'error', sso: 'SSO', support: 'support', contact: 'contact form' }
export const categoryNoun = (key, catalog) => {
  const cat = catalog && (catalog.categories || []).find(c => c.key === key)
  if (cat && cat.alertNoun) return cat.alertNoun
  if (NOUNS[key]) return NOUNS[key]
  return cat && cat.label ? cat.label.toLowerCase() : key
}

// A category-wide route never covers a platform-only alert (catalog.js
// coversTrigger): a platform route's summary names what it leaves out.
export const triggerSummary = (route, catalog) => {
  if (!route.triggerKinds || route.triggerKinds.length === 0) {
    const all = `All ${categoryNoun(route.category, catalog)} alerts`
    const left = routeOrgScoped(route) ? [] : (catalog.triggers || []).filter(t => t.category === route.category && t.platformOnly)
    return left.length ? `${all} except ${left.map(t => t.label).join(', ')}` : all
  }
  return route.triggerKinds.map(k => (catalog.triggers.find(t => t.kind === k) || { label: k }).label).join(', ')
}

export const filterSummary = route => {
  const parts = (route.filters || []).map(f => `${f.field} ${OP_WORDS[f.op] || f.op} ${Array.isArray(f.value) ? f.value.join(', ') : f.op === 'exists' ? '' : f.value}`.trim())
  if (route.minSeverity && route.minSeverity !== 'info') parts.push(`severity ≥ ${route.minSeverity}`)
  return parts.length ? parts.join(' · ') : 'Everything'
}

const dayWords = days => {
  if (!days || days.length === 0 || days.length === 7) return 'Every day'
  const set = [...days].sort((a, b) => DAYS.indexOf(a) - DAYS.indexOf(b)).join(',')
  if (set === 'mon,tue,wed,thu,fri') return 'Weekdays'
  if (set === 'sat,sun') return 'Weekends'
  return days.map(d => d[0].toUpperCase() + d.slice(1)).join(', ')
}

export const whenSummary = route => {
  const s = route.schedule
  const when = s ? `${dayWords(s.days)} ${s.from}–${s.to} ${s.timezone}` : 'Any time'
  const delivery = route.deliveryMode === 'digest' ? `digest ${route.digestMinutes} min` : 'send now'
  return `${when} · ${delivery}`
}
